import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { Config } from '@ionic/angular';

/**
 * This directive automatically adds the current Ionic mode class ('ios' or 'md') to an custom element.
 * This ensures that the element is styled according to Ionic's platform-specific design.
 * 
 * ### Example Usage:
 * ```html
 * <div autoMode>
 *   This element will have either 'ios' or 'md' class based on the Ionic mode.
 * </div>
 * ```
 */
@Directive({
    selector: '[autoMode]',
    standalone: false
})
export class AutoModeDirective {

  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
    private config: Config,
  ) {
    const mode = this.config.get("mode");
    this.renderer.addClass(this.element.nativeElement, mode);
  }
}
